import { css } from "styled-components";
import token from "styled-token";
import { typographyMixin } from "../typographyMixin";
import { animationFadeInMixin } from "../animationFadeInMixin";
import { animationZoomInMixin } from "../animationZoomInMixin";
import { StyledDialog } from "../../components/Dialog/Dialog";
import { StyledDialogHeader } from "../../components/Dialog/DialogHeader";
import { StyledDialogBody } from "../../components/Dialog/DialogBody";
import { StyledDialogFooter } from "../../components/Dialog/DialogFooter";
import { StyledDialogClose } from "../../components/Dialog/DialogClose";
import { StyledDialogLayout } from "../../components/Dialog/DialogLayout";
import { StyledMask } from "../../components/Mask/Mask";
import { StyledText } from "../../components/Text/Text";
import { DialogMixin } from "./DialogMixin";
import { ModalMixin } from "./ModalMixin";
import { spaceMixin } from "../spaceMixin";
import { overflowPaddingMixin } from "../overflowPaddingMixin";
import { overflowAutoMixin } from "../overflowAutoMixin";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";
import { MODAL_SIZES } from "../../components/ModalDialog/MODAL_SIZES";

var fullScreenCSS = function fullScreenCSS(props) {
  return token({
    borderRadius: "radii.lg",
    paddingVertical: "Modal.viewportPaddingVertical",
    paddingHorizontal: "Modal.viewportPaddingHorizontal"
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
        paddingVertical = _ref.paddingVertical,
        paddingHorizontal = _ref.paddingHorizontal;

    // In order to support backwards compatibility and `mediaQuery` prop, we have to set
    // and reset CSS based on full screen size. We can remove the else condition once
    // `mediaQuery` prop is removed and unsupported.
    if (props.size === MODAL_SIZES.FULL_SCREEN) {
      return css(["padding:0;> ", "{border-radius:0;min-height:100%;}", "{opacity:0;}"], StyledDialog, StyledMask);
    }

    return css(["padding:", "px ", "px;> ", "{border-radius:", "px;min-height:0;}", "{opacity:1;}"], paddingVertical, paddingHorizontal, StyledDialog, borderRadius, StyledMask);
  })(props);
};

var sizeCSS = function sizeCSS(props) {
  return token("ModalDialog.sizes." + props.size, function (size) {
    return css(["", " > ", "{max-width:", ";}"], fullScreenCSS(props), StyledDialog, props.size === MODAL_SIZES.FULL_SCREEN ? size + "%" : size + "px");
  })(props);
};

var scrollCSS = function scrollCSS(_ref2) {
  var scrollDocument = _ref2.scrollDocument;

  if (scrollDocument) {
    return "align-items: start;";
  }

  return css(["> ", "{max-height:100%;_:-ms-fullscreen &,&{height:100%;}}"], StyledDialog);
};
/** @class ModalDialogMixin */

/** @method */


export var ModalDialogMixin = function ModalDialogMixin(props) {
  return token({
    dividerColor: "ModalDialog.separatorColor",
    fontType: "Dialog.headingFontType",
    spacing: "ModalDialog.padding"
  }, function (_ref3) {
    var dividerColor = _ref3.dividerColor,
        fontType = _ref3.fontType,
        spacing = _ref3.spacing;
    return css(["", " ", " > ", "{", " ", " display:flex;flex-direction:column;height:auto;min-height:0;width:100%;", "{display:flex;flex:1;flex-direction:column;min-height:100%;}", "{border-bottom:", ";flex:0 0 auto;padding:", "px;text-align:center;", "{", "}}", "{", " ", ";flex:1 1 auto;margin-top:", ";}", "{border-top:", ";flex:0 0 auto;display:flex;justify-content:flex-end;padding:", "px;}", "{top:", "px;right:", "px;}}", "{opacity:1;}", " ", ""], ModalMixin(props), animationFadeInMixin(props), StyledDialog, DialogMixin(props), animationZoomInMixin(props), StyledDialogLayout, StyledDialogHeader, props.dividers ? "1px solid " + dividerColor : "none", spacing, StyledText, typographyMixin(Object.assign({
      fontType: fontType
    }, props)), StyledDialogBody, overflowAutoMixin(props), overflowPaddingMixin(spacing + "px", spacing + "px", spacing + "px"), props.renderHeader || props.header ? "0" : spaceMixin(4)(props), StyledDialogFooter, props.dividers ? "1px solid " + dividerColor : "none", spacing, StyledDialogClose, spacing, spacing, StyledMask, scrollCSS(props), inlineMediaQueryMixin("size", sizeCSS)(props));
  })(props);
};